/**
 * Frequency Enum
 *
 * Defines the recurrence frequency for costs and benefits.
 */
export const FrequencyLabel = {
    one_time: 'One-Time',
    weekly: 'Weekly',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    annually: 'Annually',
};
export const FrequencyDescription = {
    one_time: 'Single occurrence, no recurrence',
    weekly: 'Occurs every week',
    monthly: 'Occurs every month',
    quarterly: 'Occurs every 3 months',
    annually: 'Occurs once per year',
};
export const FREQUENCIES = ['one_time', 'weekly', 'monthly', 'quarterly', 'annually'];
/**
 * Number of occurrences per year for each frequency
 */
export const FrequencyPerYear = {
    one_time: 1,
    weekly: 52,
    monthly: 12,
    quarterly: 4,
    annually: 1,
};
/**
 * Approximate number of occurrences per month
 */
export const FrequencyPerMonth = {
    one_time: 0, // Special case: only first month
    weekly: 4.33,
    monthly: 1,
    quarterly: 0.33,
    annually: 0.083,
};
//# sourceMappingURL=frequency.enum.js.map